import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
class ThirdParty extends SettingsOprator {
  constructor() {
    super(fileSys.getUtilPath("thirdparty/config.json"));
  }
  getThirdPartySettings() {
    return this.getSettings();
  }
  saveThirdPartySettings(settings) {
    this.saveSettings(settings);
  }
}
export default ThirdParty;



// WEBPACK FOOTER //
// ./src/settings/thirdparty.js